import { api } from '@/api';
import { config } from '@/config';

const actions = {
    SUPERADMIN_SVG_EDIT : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('superadmin.svg.edit'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
}

export default {
    actions
};
